import { HOST_URL } from "../../../../actions/api";

let EmbedExploreData = [
    [{
        id: 1,
        name: "Tag-based Widget",
        target: "#tagWidgetModal",
        idd: "tag-based_click_from_webpage",
        image: "tag-based-widget"
    },

    {
        id: 2,
        name: "Email Campaign",
        target: "#emailCampaignModal",
        idd: "email_click_from_webpage",
        image: "email-campaign"
    },
    {
        id: 3,
        name: "Digital Display",
        target: "#digitalScreensModal",
        idd: "display_click_from_webpage",
        image: "digital-screen"
    },

    {
        id: 4,
        name: "Run Social Ads",
        target: "#socailAdsModal",
        idd: "social_ads_click_from_webpage",
        image: "run-social-ads"
    },
    {
        id: 5,
        name: "Shoppable Galleries",
        target: "#shoppableModal",
        idd: "shoppable_click_from_webpage",
        image: "make-shoppable"
    }],
    [
        {
            id: 1,
            name: "Tag-based Widget",
            text: "Now, tag and categorize similar products with the tag-based widget. Ease the customer purchase journey, amplify audience engagement, and boost sales by simply displaying product-specific widgets.",
            btnName: 'Try Now',
            videoURL: "764430821",
            labelledby: 'tagWidgetModalLabel',
            modelId: "tagWidgetModal",
            iframeID: 'TagBasedVideo',

        },

        {
            id: 2,
            name: "Email Campaign",
            modelId: "emailCampaignModal",
            iframeID: 'emailCampaignVideo',
            btnName: 'Try Now',
            videoURL: "771433320",
            text: 'Amp up your email game with UGC powered by Taggbox! Display authenticity in your email campaigns and roll out customer-centric emails that inspire',
            labelledby: 'emailCampaignModalLabel',

        },
        {
            id: 3,
            name: "Digital Display",
            modelId: "digitalScreensModal",
            iframeID: 'digitalScreensVideo',
            btnName: 'Try Taggbox Display',
            videoURL: "display.mp4",
            btnURL: `${HOST_URL}/display/walls/home`,
            text: "Display user-generated content on your permanent displays and digital screens around your premises. Grab your audience's attention with offline UGC marketing that boosts engagement.",
            labelledby: 'digitalScreensModalLabel',
        },

        {
            id: 4,
            name: "Run Social Ads",
            modelId: "socailAdsModal",
            iframeID: 'socailAdsVideo',
            btnName: 'Take Rights Now',
            videoURL: "771434260",
            btnURL: `${HOST_URL}/widget/moderation/index/${window.wallID}`,
            text: 'Add UGC in your social ads to level-up engagement  clickthroughs. Get your UGC rights from original content creators to run social ad campaigns ethically.',
            labelledby: 'socailAdsModalLabel',
        },
        {
            id: 5,
            name: "Shoppable Galleries",
            modelId: "shoppableModal",
            iframeID: 'shoppableVideo',
            btnName: 'Try Tagshop',
            videoURL: "taggshop.mp4",
            btnURL: `https://tagshop.ai`,
            text: 'Customize and tag your products to transform them into shoppable galleries. Capitalize on the users’ inspiration and boost conversion rates faster!.',
            labelledby: 'shoppableModalLabel',
        }
    ],
    [
        {
            id: 1,
            title: "Embed Widget On HTML Website",
            name: "Html",
            videoURL: "531736063",
            popupID: "html",
            classActive: 'active show',
        },
        {
            id: 2,
            title: " Embed Widget On WordPress Website",
            name: "Wordpress",
            videoURL: "531718648",
            popupID: "wordpress",
            classActive:''
    
        }, {
            id: 3,
            title: "Embed Widget On Wix Website",
            name: "Wix",
            videoURL: "531721188",
            popupID: "wix",
            classActive:''
        }, {
            id: 4,
            title: " Embed Widget on Squarespace Website",
            name: "Squarespace",
            videoURL: "543489521",
            popupID: "squarespace",
            classActive:''
    
        }, {
            id: 5,
            title: "Embed Widget on Shopify",
            name: "Shopify",
            videoURL: "543485011",
            popupID: "shopify",
            classActive:''
    
        },
        {
            id: 6,
            title: "Embed Widget On Your Websites",
            name: "Other",
            videoURL: "",
            popupID: "other",
            classActive:''
        },
    
    ]
]

export default EmbedExploreData;